import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

// Fade-up scroll reveal wrapper. Respects reduced motion via framer defaults.
export function Reveal({ children, delay = 0, y = 24, className = "", as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease, delay }}
    >
      {children}
    </MotionTag>
  );
}

// Section eyebrow label with an amber tick.
export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-amber ${className}`}>
      <span className="h-px w-6 bg-amber" aria-hidden="true" />
      {children}
    </span>
  );
}

export { ease };
